<template>
  <b-row>
    <b-col>
      <divisoria-descricao
        :titulo="'Societário'"
        :descricao="'Visualize a composição do quadro societário dessa empresa'"
      />
      <b-row>
        <b-col cols="3">
          <dinheiro-input
            v-model="empresa.capitalSocial"
            :label="'Capital social'"
            :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
          />
          <span v-if="!empresa.socios || empresa.socios.length == 0">Atenção: não há sócios vinculados a essa empresa!</span>
        </b-col>
        <b-col
          cols="3"
        >
          <upload-parametrizacao
            ref="uploadContratual"
            :disabled="disabled"
            :label="'Última alteração contratual'"
            :id-upload="'contratual'"
            :visualizar="visualizarContratual"
            :text="empresa.anexoEmpresa.nomeArquivoContratual && empresa.anexoEmpresa.nomeArquivoContratual !== '' ? empresa.anexoEmpresa.nomeArquivoContratual : empresa.anexoEmpresa.nomeArquivoContratualAntigo"
            @selecionado="selecionadoContratual"
            @removido="arquivoContratualRemovido"
          />
        </b-col>
        <b-col
          cols="3"
        >
          <upload-parametrizacao
            ref="uploadOutrosAnexos"
            :disabled="disabled"
            :label="'Outros anexos (opcional)'"
            :id-upload="'outrosAnexos'"
            :visualizar="visualizarOutros"
            :text="(empresa.anexoEmpresa.nomeArquivoOutrosAnexosAntigo && empresa.anexoEmpresa.nomeArquivoOutrosAnexosAntigo !== '') && !empresa.anexoEmpresa.nomeArquivoOutrosAnexos ? empresa.anexoEmpresa.nomeArquivoOutrosAnexosAntigo : empresa.anexoEmpresa.nomeArquivoOutrosAnexos"
            @selecionado="selecionadoOutros"
            @removido="arquivoOutrosRemovido"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <socios-empresa
            v-for="(socio, $index) in empresa.socios"
            :key="$index"
            :socio="socio"
            :disabled="true"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'AbaSocietario',
  components: {
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    SociosEmpresa: () => import('./shared/socios-empresa/SociosEmpresa.vue'),
    UploadParametrizacao: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/Geral/shared/upload-visualizacao-parametrizacao/UploadParametrizacao.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('empresa', ['empresa']),
  },
  methods: {
    selecionadoOutros(nome) {
      this.empresa.anexoEmpresa.outrosSelecionado = this.$refs.uploadOutrosAnexos.value[0] !== undefined
      this.empresa.anexoEmpresa.nomeArquivoOutrosAnexos = nome
      this.empresa.anexoEmpresa.excluirOutros = false
      this.$refs.uploadOutrosAnexos.text = nome
      this.empresa.anexoEmpresa.excluirOutros = true
    },
    selecionadoContratual(nome) {
      this.empresa.anexoEmpresa.contratualSelecionado = this.$refs.uploadContratual.value[0] !== undefined
      this.empresa.anexoEmpresa.nomeArquivoContratual = nome
      this.empresa.anexoEmpresa.excluirContratual = false
      this.$refs.uploadContratual.text = nome
      this.empresa.anexoEmpresa.excluirContratual = true
    },
    arquivoContratualRemovido() {
      this.empresa.anexoEmpresa.contratualSelecionado = false
      this.empresa.anexoEmpresa.nomeArquivoContratual = ''
      this.empresa.anexoEmpresa.nomeArquivoContratualAntigo = null
      this.empresa.anexoEmpresa.excluirContratual = true
    },
    arquivoOutrosRemovido() {
      this.empresa.anexoEmpresa.outrosSelecionado = false
      this.empresa.anexoEmpresa.nomeArquivoOutrosAnexos = ''
      this.empresa.anexoEmpresa.nomeArquivoOutrosAnexosAntigo = null
      this.empresa.anexoEmpresa.excluirOutros = true
    },
    visualizarContratual() {
      if (this.empresa.id > 0) {
        return api.getArquivoContratual(this.empresa.id, 'contrato')
      }
      return null
    },
    visualizarOutros() {
      if (this.empresa.id > 0) {
        return api.getArquivoContratual(this.empresa.id, 'outros')
      }
      return null
    },
    getArquivosAnexados() {
      return { contratual: this.$refs.uploadContratual.value[0], outros: this.$refs.uploadOutrosAnexos.value[0] }
    },
  },
}
</script>
